import { render, staticRenderFns } from "./PlaylistWrapper.vue?vue&type=template&id=a50ba354"
import script from "./PlaylistWrapper.vue?vue&type=script&lang=js"
export * from "./PlaylistWrapper.vue?vue&type=script&lang=js"
import style0 from "./PlaylistWrapper.vue?vue&type=style&index=0&id=a50ba354&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports